import { render, staticRenderFns } from "./TbFilaAtendimento.vue?vue&type=template&id=63bdf025&scoped=true&"
import script from "./TbFilaAtendimento.vue?vue&type=script&lang=js&"
export * from "./TbFilaAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./TbFilaAtendimento.vue?vue&type=style&index=0&id=63bdf025&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bdf025",
  null
  
)

export default component.exports